import { useServices } from './useServices';

export const useFileType = () => {
  return useServices().fileType;
};
